<template>
  <div class="main_right electronic-config-modify">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="收费配置" subheading="" />
      <div>
        <a @click="updateWaterPayConfig">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>

    <form>
      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收费标准：</span>
          </div>
          <el-select v-model="feeType" size="small" style="width: 280px">
            <el-option v-for="item in feeTypeList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>

      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">热水单价：</span>
          </div>
          <el-input v-model="waterConfigData.hotUnitPrice" size="small" style="width: 280px" v-on:blur="hotUnitPriceChange()">
            <template slot="append">元/吨</template>
          </el-input>
        </div>
      </div>

      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">冷水单价：</span>
          </div>
          <el-input v-model="waterConfigData.coldUnitPrice" size="small" style="width: 280px" v-on:blur="coldUnitPriceChange()">
            <template slot="append">元/吨</template>
          </el-input>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/WaterManagement'
  import TextTitle from '../../../components/Text/TextTitle'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      Breadcrumb,
      TextTitle,
    },
    name: 'modify-electronic-config',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用水',
            name: 'water-over-view'
          }, {
            value: '收费配置',
          }],
        },
        maxlength: 32,
        collectionAccountList: [],
        aliAccountName: '',
        aliAccountNo: '',
        feeType: '1',
        feeTypeList: [
          {
            code: '1',
            name: '固定定价'
          }
        ],
        waterConfigData: {
          feeType: '1',
          hotUnitPrice: '0',
          coldUnitPrice: '0',
        }

      }
    },
    created () {

    },
    mounted () {
      this.getWaterPayConfig()
    },
    methods: {
      cel () {
        this.$router.push({
          name: 'water-config-center'
        })
      },
      hotUnitPriceChange () {
        if (this.waterConfigData.hotUnitPrice) {
          this.waterConfigData.hotUnitPrice = parseFloat(this.waterConfigData.hotUnitPrice).toFixed(2)
        } else {
          this.waterConfigData.hotUnitPrice = '0.00'
        }
      },

      coldUnitPriceChange() {
        if (this.waterConfigData.coldUnitPrice) {
          this.waterConfigData.coldUnitPrice = parseFloat(this.waterConfigData.coldUnitPrice).toFixed(2)
        } else {
          this.waterConfigData.coldUnitPrice = '0.00'
        }
      },

      getWaterPayConfig () {
        this.$axios.post(api.getWaterPayConfig, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              this.waterConfigData = data
            }
          })
          .catch(errorHandler('获取收费数据失败'))
      },
      updateWaterPayConfig () {
        this.$axios.post(api.updateWaterPayConfig, this.waterConfigData)
          .then(res => {
            nSuccess('修改成功')
            this.cel()
          })
          .catch(errorHandler('修改失败'))
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }
  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
    color: #00a0e6;
  }
  .flexBox a:hover{
    color: #06b3ff;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  form>div {
    display: flex;
    justify-content: flex-start;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    line-height: 30px;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .main_right {
    .faceConfigTip {
      display: inline-block;
      min-width: 80px;
      text-align: right;
    }
    .faceConfigInput {
      display: inline-block;
      width: 313px;
      height: 28px;
      margin-left: 10px;
      .el-input__inner {
        height: 28px;
      }
    }
  }

  .electronic-config-modify {
    .el-date-editor .el-range-separator {
      width: 14px;
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/WaterConfig/WaterConfigModify.vue